<div class="attached-elements">
  <div class="attached-elements-header">
    <input nbInput fieldSize="small" placeholder="Поиск связанных элементов">
  </div>

  <div *ngFor="let item of damRelatedCollection">
    <app-dam-related-collection [model]="model" [damRelatedCollection]="item" [uri]="uri"/>
  </div>
</div>
